/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:60px;color:#9bafbb;text-align:center;background-image:linear-gradient(0deg,#fff 0,#e3eff6 100%)}@media (min-width:992px){[_nghost-%COMP%]{line-height:60px}}[_nghost-%COMP%]   .icomoon[_ngcontent-%COMP%]{display:block;font-size:3.4375rem;line-height:1}@media (min-width:768px){[_nghost-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0}}[_nghost-%COMP%]   a[_ngcontent-%COMP%]{color:inherit;font-size:.75rem}"];
export { styles as styles };
